module.exports = __webpack_public_path__ + "img/ticket.c5191427.png";